/**
 * @description 批改-變更項目-子項目名稱
 */
export enum EndorseTarget {
    /** 郵遞區號 */
    APPLICANT_POSTCODE = 'APPLICANT_POSTCODE',
    /** 縣市代碼 */
    APPLICANT_CITY_ID = 'APPLICANT_CITY_ID',
    /** 區域代碼 */
    APPLICANT_AREA_ID = 'APPLICANT_AREA_ID',
    /** 詳細地址 */
    APPLICANT_ADDRESS = 'APPLICANT_ADDRESS',
    /** 行動電話號碼 */
    APPLICANT_MOBILE = 'APPLICANT_MOBILE',
    CONTACT_MOBILE = 'CONTACT_MOBILE',
    MOBILE = 'MOBILE',
    /** EMAIL */
    APPLICANT_EMAIL = 'APPLICANT_EMAIL',
    /** 婚姻狀況 */
    APPLICANT_MARRIAGE = 'APPLICANT_MARRIAGE',
    /** 婚姻狀況-代碼 */
    APPLICANT_MARRIAGE_CODE = 'APPLICANT_MARRIAGE_CODE',
    /** 郵遞區號 */
    POSTCODE = 'POSTCODE',
    /** 縣市代碼 */
    CITY_ID = 'CITY_ID',
    /** 區域代碼 */
    AREA_ID = 'AREA_ID',
    /** 地址 */
    ADDRESS = 'ADDRESS',
    /** 名字 */
    INSURED_NAME = 'INSURED_NAME',
    APPLICANT_NAME = 'APPLICANT_NAME',
    /** 引擎號碼 */
    ENGINE_ID = 'ENGINE_ID',
    /** 車身號碼 */
    VEHICLE_ID = 'VEHICLE_ID',
    /** 車牌號碼 */
    CAR_LICENSE = 'CAR_LICENSE',
    /** 發照年月 */
    ISSUE_DATE = 'ISSUE_DATE',
    /** 出發日期(去程) */
    D_DEPARTURE_TIME = 'D_DEPARTURE_TIME',
    /** 航空代碼(去程) */
    D_AIRLINE_ID = 'D_AIRLINE_ID',
    /** 航班編號(去程) */
    D_FLIGHT_NO = 'D_FLIGHT_NO',
    /** 出發日期(回程) */
    A_DEPARTURE_TIME = 'A_DEPARTURE_TIME',
    /** 航空代碼(回程) */
    A_AIRLINE_ID = 'A_AIRLINE_ID',
    /** 航班編號(回程) */
    A_FLIGHT_NO = 'A_FLIGHT_NO',
    /** 抵押權人 */
    MORTGAGE = 'MORTGAGE',
    /** 標的物地址-路/街 */
    ADDRESS_RD_ST = 'ADDRESS_RD_ST',
    /** 標的物地址-路/街-代碼 */
    ADDRESS_RD_ST_CODE = 'ADDRESS_RD_ST_CODE',
    /** 標的物地址-巷 */
    ADDRESS_LN = 'ADDRESS_LN',
    /** 標的物地址-弄 */
    ADDRESS_ALY = 'ADDRESS_ALY',
    /** 標的物地址-號 */
    ADDRESS_NO = 'ADDRESS_NO',
    /** 標的物地址-樓 */
    ADDRESS_F = 'ADDRESS_F',
    /** 標的物地址-備註說明 */
    ADDRESS_NOTE = 'ADDRESS_NOTE',
    /** 標的物地址-號 */
    ADDRESS_NO_1 = 'ADDRESS_NO_1',
    /** 標的物地址-之號 */
    ADDRESS_NO_2 = 'ADDRESS_NO_2',
    /** 標的物地址-樓 */
    ADDRESS_F_1 = 'ADDRESS_F_1',
    /** 標的物地址-之樓 */
    ADDRESS_F_2 = 'ADDRESS_F_2'
}
